<template>
  <gh-table-page ref="table" :args-query="argsQuery" module="mes.business.mdl.measure.service" cls="MeasureService">
    <template #area_query>
      <v-layout row align-center>
        <v-text-field v-model="argsQuery.keywords" counter :autofocus="true" clearable label="关键字"
          append-icon="mdi-circle-edit-outline"></v-text-field>
      </v-layout>
    </template>
  </gh-table-page>
</template>

<style scoped>
</style>

<script>
  import Measure from "./measure.ts";
  export default Measure;
</script>